import { CURRENT_USER_KEY } from '../../constants';
import { JsonLocalStorageService } from '../local-storage-service';
import { FirebaseUser } from './types';

export const LocalStorageUserService =
  new JsonLocalStorageService<FirebaseUser>(CURRENT_USER_KEY);
